import memoize from "fast-memoize";
import { createSelector } from "reselect";

import { EntityTypesSupportingRoutes, Route } from "@mapmycustomers/shared/types/entity";

import { RootState } from "../rootReducer";

import { stateFieldBaseName } from "./util";

const routesState = (state: RootState) => state.routes;

export const companyRoutes = createSelector(routesState, ({ companyRoutes }) => companyRoutes);
export const peopleRoutes = createSelector(routesState, ({ peopleRoutes }) => peopleRoutes);

export const getRoutesForEntity = createSelector(routesState, (state) =>
  memoize(
    (entityType: EntityTypesSupportingRoutes): Route[] => state[stateFieldBaseName[entityType]]
  )
);
